import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-under-development-status',
  templateUrl: './under-development-status.component.html',
  styleUrls: ['./under-development-status.component.css']
})
export class UnderDevelopmentStatusComponent { }
